import React from 'react';

const LicensesBatchMonoPage = React.lazy(() => import('../pages/licensesBatchMono/LicensesBatchMonoPage/LicensesBatchMonoPage'));
const LicenseBatchMonoCreatePage = React.lazy(() => import('../pages/licensesBatchMono/LicenseBatchMonoCreatePage/LicenseBatchMonoCreatePage'));
const LicenseBatchMonoDetailPage = React.lazy(() => import('../pages/licensesBatchMono/LicenseBatchMonoDetailPage/LicenseBatchMonoDetailPage'));

export const PATH_LICENSE_BATCHS_MONO = '/licenses-batch-mono';
export const PATH_LICENSE_BATCH_MONO_CREATE = '/license-batch-mono/create';
export const PATH_LICENSE_BATCH_MONO = '/license-batch-mono/:guid/:step?';
export const getPathLicenseBatchMono = (guid) => `/license-batch-mono/${guid}/1`;

const PAGE_LICENSE_BATCHS_MONO = {
  component: LicensesBatchMonoPage,
  path: PATH_LICENSE_BATCHS_MONO,
};

const PAGE_LICENSE_BATCH_MONO_CREATE = {
  component: LicenseBatchMonoCreatePage,
  path: PATH_LICENSE_BATCH_MONO_CREATE,
};

const PAGE_LICENSE_BATCH_MONO = {
  component: LicenseBatchMonoDetailPage,
  path: PATH_LICENSE_BATCH_MONO,
};

// IMPORTANT: The order in which the pages are added is important
export default [PAGE_LICENSE_BATCH_MONO_CREATE, PAGE_LICENSE_BATCH_MONO, PAGE_LICENSE_BATCHS_MONO];
